import clsx from 'clsx';
import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { IconWarning } from '~/ui/core/icons';
import { Tooltip } from '~/ui/core/tooltip/Tooltip';

import { useWarningSignalsVisible } from '../../app/common/hooks/use-warning-signals-visible';

export const SkillNotSyncedWarning: FunctionComponent<{
    readonly className?: string;
    readonly isSynced: boolean | undefined;
}> = ({ className, isSynced }) => {
    const translate = useTranslate();
    const isWarningSignalsVisible = useWarningSignalsVisible();

    if (!isWarningSignalsVisible || isSynced !== false) {
        return null;
    }

    return (
        <Tooltip>
            <Tooltip.Trigger asChild={true}>
                <IconWarning
                    className={clsx('text-warning-500 shrink-0', className)}
                    data-testid="skill-not-synced-warning"
                    size={16}
                />
            </Tooltip.Trigger>
            <Tooltip.Portal>
                <Tooltip.Content side="top">
                    {translate('pages.job-architecture-v2.skills.not-synced-tooltip')}
                </Tooltip.Content>
            </Tooltip.Portal>
        </Tooltip>
    );
};
